import { CalendarOutlined, CopyOutlined, DownOutlined, EditOutlined, ReloadOutlined, UpOutlined, UserAddOutlined } from '@ant-design/icons';
import { PaginationProps, Switch, Tabs, TabsProps, TreeSelect } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { memo, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { editCustomerByGroup, exportListGroupCustomerExcel, getDetailGroup, getListAllCustomer, getListCustomerByGroup, IDetailGroup } from '../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { group_share, group_share_active, team_count, user_private, user_private_active } from '../../../../../components/ExportImgFigma';
import useDebounce from '../../../../../hook/useDebounce';
import useLoading from '../../../../../hook/useLoading';
import useThrottle from '../../../../../hook/useThrottle';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import '../../style.scss';
import { CONDITION, dataDefaulFilterList, generateColumnsFromCodesAgGridReactGroup, GROUPTYPE, IDataFilterGroupList, ILastIdGroupCustomer } from '../AddGroup/AddNewGroup';
import { NodeEvent } from '../SideBar';
import ItemConditionDisplay from './components/ItemConditionDisplay';
import VG_Decentralization from './components/VG_Decentralization';
import VG_History from './components/VG_History';
import VG_List from './components/VG_List';
import { ISelectedUserAccount } from '../EditGroup/ConditionEdit/EG_Decentralization';
import { convertTreeForAntd, EDisplayGroupType, useCustomerGroupContext } from '../../indexV2';
import { useNavigate } from 'react-router-dom';
import { NO_DATA, NO_VIEW } from '../../../../../services/data';
import { getLastIdList, getUserPermissions } from '../../../../../until';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import { formatNumber } from '../../../../../services/mixin';
import { selectorPermission } from '../../../../../store/slices/permissionSlice';
import { ISelectedCustomer } from '../EditGroup/EditGroup';
import { BATCH_SIZE } from '../../../../../env';
import { PERMISSION } from '../AddGroup/Component/AG_Decentralization';
import { ColDef } from 'ag-grid-community';



interface Props {
  // inforNodeEvent?: NodeEvent
  // setInforNodeEvent: (e?: NodeEvent) => void
}

const ViewGroup: React.FC<Props> = ({

}) => {
  useEffect(() => {
  }, [])

  const pushLoading = useLoading()
  const navigator = useNavigate()


  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)
  const { unitTemp, unit, id } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const {
    displayType, inforNodeEvent, dataFieldsActive,
    ColumnsMapShow, listGroup,
    setInforNodeEvent
  } = useCustomerGroupContext();

  const [isMore, setMore] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState<boolean>(false)

  const [groupType, setGroupType] = useState(GROUPTYPE.PRIVATE)


  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [dataFilterList, setDataFilterList] = useState<IDataFilterGroupList>(dataDefaulFilterList)

  const [selectedIdCustomer, setSelectedIdCustomer] = useState<Set<number>>(new Set());
  const [lastId, setLastId] = useState<ILastIdGroupCustomer>()

  const [listUserSelectedAccount, setListUserSelectedAccount] = useState<ISelectedUserAccount[]>([]);

  const [inforGroup, setInforGroup] = useState<IDetailGroup>()
  const [listCustomerNoAutomatic, setlistCustomerNoAutomatic] = useState<any[]>([])



  const tableDataCustomerNoAutomatic: any[] = useMemo(() => {
    return listCustomerNoAutomatic.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listCustomerNoAutomatic])


  const actionColumn: ColDef = {
    headerName: 'Nguồn',
    width: 110,
    resizable: false,
    pinned: 'left',
    suppressMovable: true,
    lockPosition: 'left',
    cellRenderer: (params: any) => {
      return !params.data.addType ?
        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              height: '30px',
              padding: '2px 8px',
              backgroundColor: '#F6FFED',
              color: '#52C41A',
              border: '1px solid #52C41A',
              fontSize: 14
            }}
          >

            <span>Thủ công</span>
          </div>
        </div >

        :

        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              height: '30px',
              padding: '2px 8px',
              backgroundColor: '#E6F7FF',
              color: '#40A9FF',
              border: '1px solid #40A9FF',
              fontSize: 14
            }}
          >

            <span>Điều kiện</span>
          </div>
        </div >
    }

  }




  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactGroup(
      ColumnsMapShow, dataFieldsActive, actionColumn,
      (id: number, next: boolean, rowData: any) =>
        navigator(
          `/customer/list/edit`,
          {
            state: {
              firstPage: "/customer/group",
              id: rowData?.data?.id,
              inforNodeEvent: {
                ...inforNodeEvent,
                action: "view",
              }
            }
          }
        ),

      ['own_vehicle_brand', 'own_vehicle_type_category', 'own_vehicle_model', 'own_vehicle_name', 'own_vehicle_color']
    );
  }, [ColumnsMapShow, inforGroup, listCustomerNoAutomatic, inforNodeEvent]);

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListCustomerNoAutomatic(pageNumber, pageSize)
  }

  //XUAT EXEL TẤT CẢ DANH SÁCH -------
  const eListGroupCustomerExcel = useThrottle(async (type: number) => {
    const { id, title } = inforGroup ?? {}

    if (id && title) {
      pushLoading(true)
      await exportListGroupCustomerExcel(
        id, unitTemp, title, type
      )
      pushLoading(false)
    }
  }, 1000)

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css text-base font-regular'>
        Danh sách khách hàng
      </span>,
      children:
        <VG_List
          inforGroup={inforGroup}
          memoizedColumnDefs={memoizedColumnDefs}
          listCustomerNoAutomatic={tableDataCustomerNoAutomatic}

          pagination={pagination}
          dataFilterList={dataFilterList}
          selectedIdCustomer={selectedIdCustomer}

          setDataFilterList={setDataFilterList}
          setSelectedIdCustomer={setSelectedIdCustomer}
          onPaginationChange={onPaginationChange}
          eListGroupCustomerExcel={eListGroupCustomerExcel}
        />,
    },

    ...(groupType !== GROUPTYPE.PRIVATE
      ? [
        {
          key: '2',
          label: <span className="custom-page-css text-base font-regular">
            Phân quyền ({inforGroup?.listAdmin?.length ?? 0})
          </span>,
          children:
            <VG_Decentralization
              isEdit={isEdit}
              inforGroup={inforGroup}
              listUserSelectedAccount={listUserSelectedAccount}
              setListUserSelectedAccount={setListUserSelectedAccount}
            />,
        },
      ]
      : []),
    {
      key: '3',
      label: <span className='custom-page-css text-base font-regular'>Lịch sử</span>,
      children:
        <VG_History
          inforGroup={inforGroup}
        />,
    },
  ];


  const gListCustomerNoAutomatic = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const {
      listCategoryCar, listUnit, search
    } = dataFilterList

    const lastIdTmp = pageCurent === 1 ? undefined : lastId

    const result = await getListCustomerByGroup(
      permittedCategoryCarIds,
      pageSize, pageCurent, search, unitTemp ?? undefined,
      listUnit, listCategoryCar, inforGroup?.id, undefined,
      undefined, undefined, lastIdTmp?.noCond
    )
    if (result?.status) {
      setlistCustomerNoAutomatic(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize })

      setLastId({ ...lastId, noCond: getLastIdList(result.data) })
    } else {
      // pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)


  const gInforGroup = async (id: number, unitTemp: number) => {
    pushLoading(true)

    const result = await getDetailGroup(permittedCategoryCarIds, id, unitTemp)
    if (result?.status) {
      const { type, status, listCustomer } = result.data
      setGroupType(status)
      setSelectedIdCustomer(new Set(listCustomer))
      setInforGroup(result.data)
      setMore(result.data.infoFilter?.conditions.length ? true : false)
    } else {
      // pushToast(result?.message, "warning")
    }
    pushLoading(false)

  }

  const handleChange = (field: keyof IDetailGroup, value: any) => {
    // setInforViewGroup({
    //     ...inforViewGroup,
    //     [field]: value,
    // });

  };

  const editCustomersInChunks = async (
    selectedIdCustomerV9: ISelectedCustomer[],
    idGroup: number
  ) => {
    for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
      const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

      let success = false;
      let retryCount = 0;

      while (!success) {
        try {
          await editCustomerByGroup(chunk, idGroup);
          success = true;
        } catch (error) {
          retryCount++;

          console.error(
            `Chunk ${i / BATCH_SIZE + 1} failed (retry ${retryCount})`,
            error
          );

          await new Promise((r) => setTimeout(r, 1000));
        }
      }

      await new Promise((r) => setTimeout(r, 50));
    }

    // tất cả batch đã chạy thành công
    return true;
  };

  const handleReset = async () => {
    if (!inforGroup?.infoFilter) return // chỉ chạy khi nhóm có điều kiện
    pushLoading(true)
    // gọi all KH mới để lấy id match với đk
    const resultAllCustomer = await getListAllCustomer(
      permittedCategoryCarIds,
      unitTemp, inforGroup?.infoFilter.conditions, undefined, undefined
    )
    if (resultAllCustomer.status) {
      // đẩy lên bằng api edit chunk
      const resultChunk = await editCustomersInChunks(resultAllCustomer.data, inforGroup.id)
      if (resultChunk && inforNodeEvent?.item?.key) {
        // chunk trả về true nghĩa là đã chạy thành công thì gọi lại api table
        await gInforGroup(Number(inforNodeEvent.item.key), Number(unitTemp))
        gListCustomerNoAutomatic()

      }

    }
    pushLoading(false)

  };

  const handleClone = async () => {
    const { status, type, title, description, infoFilter } = inforGroup ?? {}
    const { key, parentId, level } = inforNodeEvent?.item ?? {}
    setInforNodeEvent({
      action: "clone",
      dataClone: {
        parentId: parentId,
        level: level,
        status: status ?? GROUPTYPE.PRIVATE,
        type: CONDITION.YES,
        title: `${title}-Copy`,
        description: description,
        infoFilter: infoFilter
      }
    })

  };


  const checkPermission = () => {
    if (id === 1) { // admin luôn có mọi quyền
      setIsEdit(true)
      return
    }

    const isEditTmp = inforGroup?.listAdmin.find(item => item.adminId === id)?.permissionType
    if (isEditTmp !== PERMISSION.VIEW && edit) {
      setIsEdit(true)
    } else {
      setIsEdit(false)
    }
  }

  useEffect(() => {
    checkPermission()
    if (inforGroup?.id) {
      gListCustomerNoAutomatic()
    }
  }, [inforGroup?.id, dataFilterList])

  useEffect(() => {
    if (inforNodeEvent?.action === "view" && inforNodeEvent.item?.key) {
      gInforGroup(Number(inforNodeEvent.item.key), Number(unitTemp))
    } else {
      setMore(false)

      setInforGroup(undefined)
    }
  }, [inforNodeEvent])

  return (
    <div className={`custom-page-css w-full flex flex-col relative ${displayType === EDisplayGroupType.TREE ? 'py-3 pr-3 pl-1' : ''} `}>
      <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4  rounded">
        <div className="custom-page-css w-full flex items-center justify-between">
          <div className="custom-page-css w-full flex items-center gap-2 ">
            <span className='custom-page-css text-base font-regular w-100px'>Loại nhóm</span>
            <div className={`${inforGroup?.status === GROUPTYPE.PRIVATE ? 'border-91D5FF bg-E6F7FF' : 'border'} custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
            // onClick={() => setGroupType(GROUPTYPE.PRIVATE)}
            >
              <div className="custom-page-css flex items-center justify-center">
                <img src={inforGroup?.status === GROUPTYPE.PRIVATE ? user_private_active : user_private} alt="" />
              </div>
              <span
                className={`${inforGroup?.status === GROUPTYPE.PRIVATE ? 'text-1890FF' : 'text-98A2B3'} custom-page-css text-base  font-regular`}
              >
                Nhóm riêng tư
              </span>
            </div>
            <div
              className={`${inforGroup?.status === GROUPTYPE.SHARED ? 'border-91D5FF bg-E6F7FF' : 'border'} custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
            // onClick={() => setGroupType(GROUPTYPE.SHARED)}
            >
              <div className="custom-page-css flex items-center justify-center">
                <img src={inforGroup?.status === GROUPTYPE.SHARED ? group_share_active : group_share} alt="" />
              </div>
              <span
                className={`${inforGroup?.status === GROUPTYPE.SHARED ? 'text-1890FF' : 'text-98A2B3'} custom-page-css text-base  font-regular`}
              >
                Nhóm có thể chia sẻ
              </span>
            </div>
          </div>
          <div className="custom-page-css w-full flex items-center justify-end gap-2">
            {
              inforGroup?.infoFilter &&
              <div className={` border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer  ${isEdit ? '' : 'disabled'}`}
                onClick={handleReset}
              >
                <span className={` custom-page-css text-096DD9 text-base  font-regular`}>Cập nhật KH</span>
                <ReloadOutlined className='custom-page-css text-096DD9' />
              </div>
            }
            {
              inforGroup?.type === CONDITION.YES ?
                <div className={` border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer `}
                  onClick={handleClone}
                >
                  <span className={` custom-page-css text-096DD9 text-base  font-regular`}>Nhân bản</span>
                  <CopyOutlined className='custom-page-css text-096DD9' />
                </div> :
                null
            }


            <div className={`  bg-096DD9 border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer  ${isEdit ? '' : 'disabled'}`}
              onClick={() => setInforNodeEvent({ action: "update", item: inforNodeEvent?.item })}
            >
              <span className={` custom-page-css text-white text-base  font-regular`}>Sửa nhóm</span>
              <EditOutlined className='text-white' />
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center gap-2 ">
          <span className='custom-page-css text-base font-regular w-100px'>Tên nhóm</span>
          <span className={` custom-page-css text-base text-344054  font-bold`}>{inforGroup?.title}</span>


        </div>
        <div className="custom-page-css w-full flex items-start gap-2 ">
          <span className='custom-page-css text-base font-regular w-100px shrink-0'>Mô tả</span>
          <span className={` custom-page-css text-base text-344054  font-bold`}>{inforGroup?.description}</span>
          {/* <span className={` custom-page-css text-base  font-regular`}>Khách hàng SR Nguyễn Văn Trỗi (DL) của tôi</span> */}

        </div>
        {inforGroup?.parentTitle &&
          <div className="custom-page-css w-full flex items-start gap-2 ">
            <span className='custom-page-css text-base font-regular w-100px shrink-0'>Nhóm chính</span>
            <span className={` custom-page-css text-base text-344054  font-bold`}>{inforGroup?.parentTitle}</span>
            {/* <span className={` custom-page-css text-base  font-regular`}>Khách hàng SR Nguyễn Văn Trỗi (DL) của tôi</span> */}

          </div>
        }

        {/* {displayType === EDisplayGroupType.LIST &&
                    <div className="custom-page-css w-full flex items-start gap-2 ">
                        <span className='custom-page-css text-base font-regular w-100px shrink-0'>Nhóm cha</span>
                        <TreeSelect
                            disabled
                            className='custom-page-css w-full  border rounded'
                            style={{ width: '100%' }}
                            value={inforGroup?.parentId === 0 ? undefined : inforGroup?.parentId}
                            styles={{
                                popup: { root: { maxHeight: 400, overflow: 'auto' } },
                            }}
                            placeholder="Chọn nhóm cha"
                            allowClear

                            treeDefaultExpandAll
                            // onSelect={onChangeTreeSelect}
                            treeData={convertTreeForAntd(listGroup)}
                        // onPopupScroll={onPopupScroll}
                        />

                    </div>
                } */}
        <div className="custom-page-css w-full flex items-center gap-2 pt-2">
          <div className="custom-page-css flex flex-1 items-center gap-2">
            <CalendarOutlined className='custom-page-css text-096DD9' />
            <span className='custom-page-css text-sm font-regular text-344054'>Tạo ngày</span>
            <span className='custom-page-css text-sm font-regular text-667085'>{inforGroup?.dateCreate}</span>
          </div>
          <div className="custom-page-css flex flex-1 items-center justify-center gap-2">
            <div className="h-4 w-4 overflow-hidden">
              <img src={team_count} alt="" className=' object-cover' />
            </div>
            <span className='custom-page-css text-sm font-regular text-344054'>Số lượng</span>
            <span className='custom-page-css text-sm font-regular text-667085'>{formatNumber(inforGroup?.listCustomer?.length ?? 0)}</span>
          </div>
          <div className="custom-page-css flex flex-1 items-center justify-end gap-2">
            <UserAddOutlined className='custom-page-css text-096DD9' />
            <span className='custom-page-css text-sm font-regular text-344054'>Người tạo nhóm</span>
            <span className='custom-page-css text-sm font-regular text-667085'>{inforGroup?.adminName}</span>
          </div>
        </div>
        {inforGroup?.type === CONDITION.YES &&
          <>
            <div className="custom-page-css w-full flex flex-1 items-center justify-between gap-2">
              <div className="custom-page-css flex items-center gap-2">
                <span className='custom-page-css text-base font-regular whiteSpace-nowrap'>Tự động thêm khách hàng có cùng điều kiện</span>
                <Switch
                  checked={inforGroup?.type === CONDITION.YES}
                  onChange={() => handleChange("type", inforGroup?.type == CONDITION.YES ? CONDITION.NO : CONDITION.YES)}
                />

              </div>
              {(isMore) ?
                <UpOutlined className='custom-page-css text-base text-98A2B3' onClick={() => setMore(!isMore)} />
                :
                <DownOutlined className='custom-page-css text-base text-98A2B3' onClick={() => setMore(!isMore)} />
              }
            </div>
            {isMore &&
              <div className="custom-page-css flex flex-col gap-2 flex-1">
                <div className="custom-page-css flex gap-2 flex-1">
                  <div className="custom-page-css flex flex-col gap-2 flex-1">
                    <span className='custom-page-css text-base text-344054 font-regular'>Trường</span>

                  </div>
                  <div className="custom-page-css flex flex-col gap-2 flex-1">
                    <span className='custom-page-css text-base text-344054 font-regular'>Điều kiện</span>
                  </div>
                  <div className="custom-page-css flex flex-col gap-2 flex-1">
                    <span className='custom-page-css text-base text-344054 font-regular'>Giá trị</span>
                  </div>
                </div>
                <div className="custom-page-css flex flex-col flex-1">
                  {
                    inforGroup?.infoFilter?.conditions?.map((item, i) => (
                      <div
                        key={i}
                        className="custom-page-css flex gap-2 flex-1"
                      >
                        <div className="custom-page-css flex flex-col gap-2 flex-1">
                          <span className='custom-page-css text-base text-344054 font-medium'>
                            {
                              inforGroup?.infoFilter?.typeCondition === 1 && i !== 0 &&
                              <span className='pr-2'>  {item.logicOperator}</span>
                            }
                            {item.CustomerField?.label}
                          </span>
                        </div>
                        <div className="custom-page-css flex flex-col gap-2 flex-1">
                          <span className='custom-page-css text-base text-344054 font-medium'>
                            {item?.condition?.label}
                          </span>
                        </div>
                        <div className="custom-page-css flex gap-2 flex-1">
                          <ItemConditionDisplay
                            item={item}
                          />
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            }
          </>
        }
      </div>
      <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4  rounded">
        <Tabs
          defaultActiveKey="1"
          items={items}
          // onChange={onChange}
          className='w-full'
        />
      </div>

    </div>
  )
}
export default memo(ViewGroup)
